<template>
  <b-overlay :show="showoverlay">

    <div class="row mb-4">
      <div class="col-12">
        <div class="row mb-3 align-items-center">
          <div class="col-12 col-md-4 pl-0">
            <h5 class="mb-0">Department-wise Attendance Summary</h5>
          </div>
          <div class="col-12 col-md-8 pr-0 d-flex justify-content-md-end justify-content-start align-items-center mt-2 mt-md-0">
            <b-form-group id="summary_date-group" label-for="summary_date" class="mb-0 mr-3" style="width: 200px;">
              <b-input-group class="mb-0">
                <b-form-input @input="getDepartmentAttendanceSummary(0)" :max="today" id="summary_date" name="summary_date" v-model="summary_filter.date"
                  type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>

                <b-input-group-append class="mb-0">
                  <b-form-datepicker @input="getDepartmentAttendanceSummary(0)" :max="today" id="summary_date_picker"
                    v-b-tooltip.hover.top="'Select the summary end date.'" button-only right locale="en-US"
                    v-model="summary_filter.date"></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-button variant="secondary" class="custom-secodary-btn mr-2" v-b-toggle.sidebar_right_approver_summary>
              <b-icon icon="funnel-fill" class="mr-1"></b-icon> Filter
            </b-button>
            <b-button variant="primary" @click="getDepartmentAttendanceSummary(1)">
              <b-icon icon="download" class="mr-1"></b-icon> Download Excel
            </b-button>
          </div>
        </div>

        <b-sidebar id="sidebar_right_approver_summary" title="Filter Options" right shadow>
          <template v-slot:default="{ hide }">
            <div class="px-3 py-3 text-left">
              <b-form-group label="Branch" label-for="summary_branch_id" class="mb-3">
                <b-form-select id="summary_branch_id" v-model="summary_filter.branch_id"
                  :options="branch_options"></b-form-select>
              </b-form-group>

              <b-form-group label="Department" label-for="summary_department_id" class="mb-3">
                <b-form-select id="summary_department_id" v-model="summary_filter.department_id"
                  :options="department_options"></b-form-select>
              </b-form-group>

              <b-form-group label="Job Position" label-for="summary_jobposition_id" class="mb-3">
                <b-form-select id="summary_jobposition_id" v-model="summary_filter.jobposition_id"
                  :options="jobposition_options"></b-form-select>
              </b-form-group>

              <b-form-group label="Employee Type" label-for="summary_employee_type_id" class="mb-3">
                <b-form-select id="summary_employee_type_id" v-model="summary_filter.employee_type_id"
                  :options="employee_type_options"></b-form-select>
              </b-form-group>

              <div class="mt-4 row">
                <div class="col-6">
                  <b-button variant="primary" block title="Set Filter" @click="getDepartmentAttendanceSummary(0); hide();">Apply Filter</b-button>
                </div>
                <div class="col-6">
                  <b-button variant="secondary" block title="Clear Filter" @click="resetSummaryFilter(); hide();">Clear Filter</b-button>
                </div>
              </div>
            </div>
          </template>
        </b-sidebar>
      </div>
      <div class="col-sm-12 px-0">
        <div class="table-responsive col-12">
          <table class="table table-bordered table-hover dataTable">
            <thead>
              <tr class="table-head">
                <th>S.N</th>
                <th>Department</th>
                <th class="text-center">Present</th>
                <th class="text-center">Late</th>
                <th class="text-center">Early Out</th>
                <th class="text-center">Absent</th>
                <th class="text-center">Leave</th>
                <th class="text-center" v-if="roster == 1">Night Shift</th>
                <th class="text-center" v-else>Night Duty</th>
                <th class="text-center">Off Day</th>
                <th class="text-center">Unassigned</th>
                <th class="text-center">Total</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(row, index) in department_summary" :key="row.department_id || index">
                <td>{{ index + 1 }}</td>
                <td>{{ row.department || '-' }}</td>
                <td class="text-center">{{ row.present }}</td>
                <td class="text-center">{{ row.late }}</td>
                <td class="text-center">{{ row.early }}</td>
                <td class="text-center">{{ row.absent }}</td>
                <td class="text-center">{{ row.leave }}</td>
                <td class="text-center">{{ row.night_shift }}</td>
                <td class="text-center">{{ row.weekly_off }}</td>
                <td class="text-center">{{ row.unassigned }}</td>
                <td class="text-center">{{ row.total }}</td>
              </tr>
              <tr class="s-tfoot">
                <td colspan="2">Total</td>
                <td class="text-center">{{ summaryTotal.present }}</td>
                <td class="text-center">{{ summaryTotal.late }}</td>
                <td class="text-center">{{ summaryTotal.early }}</td>
                <td class="text-center">{{ summaryTotal.absent }}</td>
                <td class="text-center">{{ summaryTotal.leave }}</td>
                <td class="text-center">{{ summaryTotal.night_shift }}</td>
                <td class="text-center">{{ summaryTotal.weekly_off }}</td>
                <td class="text-center">{{ summaryTotal.unassigned }}</td>
                <td class="text-center">{{ summaryTotal.total }}</td>
              </tr>

              <tr class="table-head">
                <td colspan="2" class="text-left rounded-0">Ratio</td>
                <td class="text-center">{{ summaryRatio.present }}%</td>
                <td class="text-center">{{ summaryRatio.late }}%</td>
                <td class="text-center">{{ summaryRatio.early }}%</td>
                <td class="text-center">{{ summaryRatio.absent }}%</td>
                <td class="text-center">{{ summaryRatio.leave }}%</td>
                <td class="text-center">{{ summaryRatio.night_shift }}%</td>
                <td class="text-center">{{ summaryRatio.weekly_off }}%</td>
                <td class="text-center">{{ summaryRatio.unassigned }}%</td>
                <td class="text-center rounded-0">{{ summaryRatio.total }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Attendance Legend -->
    <div class="d-flex flex-wrap align-items-center mt-2 mb-5 px-2 pt-2 border rounded bg-wash">
      <span v-if="roster == 1" class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.scheduled }"><b-icon icon="calendar-check-fill" class="mr-1"></b-icon> Scheduled</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.present }"><b-icon icon="person-check-fill" class="mr-1"></b-icon> Present</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.absent }"><b-icon icon="person-x-fill" class="mr-1"></b-icon> Absent</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.late }"><b-icon icon="person-badge-fill" class="mr-1"></b-icon> Late</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.early_out }"><b-icon icon="person-fill" class="mr-1"></b-icon> Early Out</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.late__early_out }"><b-icon icon="person-dash-fill" class="mr-1"></b-icon> Late & Early
        Out</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.on_leave }"><b-icon icon="person-dash-fill" class="mr-1"></b-icon> Full Day Leave</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.present }"><b-icon icon="circle-half" class="mr-1"></b-icon> First Half Leave</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.present }"><b-icon icon="circle-half" class="mr-1 rotate-180"></b-icon> Second Half
        Leave</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.on_leave }"><b-icon icon="clipboard-check" class="mr-1"></b-icon> Leave Pending</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.holiday }"><b-icon icon="calendar-fill" class="mr-1"></b-icon> Holiday</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.off_day }"><b-icon icon="calendar-minus" class="mr-1"></b-icon> Off-Day</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.overtime }"><b-icon icon="hourglass-split" class="mr-1"></b-icon> Overtime</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.compensatory_off }"><b-icon icon="calendar-plus" class="mr-1"></b-icon> Compensatory
        Off</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: legends.unassigned }"><b-icon icon="dash-square" class="mr-1"></b-icon> Unassigned</span>
      <span class="px-2 py-1 border rounded d-inline-flex align-items-center text-nowrap mr-2 mb-2"
        :style="{ color: '#dc3545' }"><b-icon icon="person-dash-fill" class="mr-1"></b-icon> Attendance Without
        Schedule</span>
    </div>

    <h5>View employees attendance details for the selected month.</h5>
    <div class="clearfix row py-2 mb-2 no-margin align-items-center">
      <div class="col-12 col-md-6 pl-0 mb-2 mb-md-0">
        <div class="custom-search border rounded">
          <b-input-group class="mb-0">
            <b-input-group-prepend is-text>
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>

            <b-form-input type="search" placeholder="Search.." v-model="search"
              @input="resetPagination()"></b-form-input>
          </b-input-group>
        </div>
      </div>

      <div class="col-10 col-md-5 pl-0">
        <div class="row no-gutters">
          <div class="col-12 col-md-6 pr-sm-2 mb-2 mb-sm-0">
            <b-input-group class="mb-0 flex-nowrap">
              <b-input-group-prepend is-text>
                Year
              </b-input-group-prepend>

              <b-form-select id="year" name="year" v-model="year" :options="$year_options"
                @change="reloadData()"></b-form-select>
            </b-input-group>
          </div>

          <div class="col-12 col-md-6 pl-sm-2">
            <b-input-group class="mb-0 flex-nowrap">
              <b-input-group-prepend is-text>
                Month
              </b-input-group-prepend>

              <b-form-select id="month" name="month" v-model="month" :options="$month_options"
                @change="reloadData()"></b-form-select>
            </b-input-group>
          </div>
        </div>
      </div>

      <div class="col-2 col-md-1 pl-0 text-right">
        <b-icon @click="downloadData" variant="info" icon="cloud-download" font-scale="2"
          class="cursor-pointer"></b-icon>
      </div>
    </div>

    <div class="row justify-content-center no-margin">

      <div class="col-sm-12 px-0">
        <div class="w-100 d-block" style="overflow-x: auto; overflow-y: hidden; max-width: 100%;">
          <table class="table attendance-table table-sticky text-nowrap mb-0 border"
            style="min-width: 100%; width: 100%;">
            <thead class="table-head" style="">
              <tr>
                <td class="">Employee</td>
                <td class="" align="center" v-for="(day_details, n) in week_days_header" :key="n"
                  v-bind:style="{ backgroundColor: head_color[day_details.day] }">
                  <div :title="day_details.title" v-b-tooltip>{{ n }}</div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(attendance, temp) in paginatedData" :key="attendance.id">
                <td>{{ attendance.name }}</td>
                <td v-for="(day_details, d) in week_days_header" :key="d" class="text-center">
                  <template v-if="!moment({ year: year, month: month - 1, day: d }).isAfter(moment(), 'day')">
                    <template v-if="attendance.attendances_list_by_day[d]">
                      <template v-for="att in attendance.attendances_list_by_day[d]">
                        <!-- Unassigned (without shift) -->
                        <div class="cursor-pointer mb-1"
                          v-b-tooltip.hover.top="att.label == -1 ? 'Activity Log: ' + att.activity_log : 'Unassigned'"
                          v-if="att.shift == null && !([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].includes(att.label))">
                          <b-icon :icon="att.label == -1 ? 'person-dash-fill' : 'dash-square'"
                            :style="{ color: att.label == -1 ? '#dc3545' : '#6c757d' }" class="fs-4"></b-icon>
                        </div>

                        <!-- Click to Resolve (Scheduled but unresolved past day) -->
                        <div class="cursor-pointer mb-1" @click="requestAdjustmentForSubordinate(att)" v-if="att.label == 0 && att.shift != null"
                            v-b-tooltip.hover.top="'Absent'">
                            <b-icon icon="person-x-fill" class="fs-4" :style="{ color: legends.absent }"></b-icon>
                        </div>

                        <!-- Leave Pending -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 7" v-b-tooltip.hover.top="'Leave Pending'">
                          <b-icon icon="clipboard-check" class="fs-4" :style="{ color: legends.on_leave }"></b-icon>
                        </div>

                        <!-- Leave Rejected -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 8" v-b-tooltip.hover.top="'Leave Rejected'">
                          <b-icon icon="clipboard-x" class="fs-4" :style="{ color: legends.on_leave }"></b-icon>
                        </div>

                        <!-- Swapped -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 13" v-b-tooltip.hover.top="'Swapped'">
                          <b-icon icon="arrow-down-up" class="fs-4" :style="{ color: legends.swapped }"></b-icon>
                        </div>

                        <!-- Present -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="[1, 11].includes(att.label)"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-check-fill" class="fs-4" :style="{ color: legends.present }"></b-icon>
                        </div>

                        <!-- Late -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 3"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-badge-fill" class="fs-4" :style="{ color: legends.late }"></b-icon>
                        </div>

                        <!-- Early Out -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 4"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-fill" class="fs-4" :style="{ color: legends.early_out }"></b-icon>
                        </div>

                        <!-- Late & Early Out -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 5"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-dash-fill" class="fs-4"
                            :style="{ color: legends.late__early_out }"></b-icon>
                        </div>

                        <!-- Absent -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 2" @click="requestAdjustmentForSubordinate(att)" v-b-tooltip.hover.top="'Absent'">
                          <b-icon icon="person-x-fill" class="fs-4" :style="{ color: legends.absent }"></b-icon>
                        </div>

                        <!-- On Leave (and half-leaves) -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 6"
                          v-b-tooltip.hover.top="att.label_text == 'x' ? 'On Leave' : att.label_text">
                          <b-icon v-if="att.label_text == 'On Leave' || att.label_text == 'x'" icon="person-dash-fill"
                            class="fs-4" :style="{ color: legends.on_leave }"></b-icon>
                          <b-icon v-else-if="att.label_text == 'First Half Leave'" icon="circle-half" class="fs-4"
                            :style="{ color: legends.present }"></b-icon>
                          <b-icon v-else-if="att.label_text == 'Second Half Leave'" icon="circle-half"
                            class="fs-4 rotate-180" :style="{ color: legends.present }"></b-icon>
                        </div>

                        <!-- Off Day -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 10" v-b-tooltip.hover.top="'Off Day'">
                          <b-icon icon="calendar-minus" class="fs-4" :style="{ color: legends.off_day }"></b-icon>
                        </div>

                        <!-- Compensatory Off Day -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 12"
                          v-b-tooltip.hover.top="'Compensatory Off Day'">
                          <b-icon icon="calendar-plus" class="fs-4"
                            :style="{ color: legends.compensatory_off }"></b-icon>
                        </div>

                        <!-- Holiday -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 9" v-b-tooltip.hover.top="'Holiday'">
                          <b-icon icon="calendar-fill" class="fs-4" :style="{ color: legends.holiday }"></b-icon>
                        </div>

                        <!-- Overtime -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)"
                          v-if="att.label == 14 && (att.check_in != '' || att.check_out != '')"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="hourglass-split" class="fs-4" :style="{ color: legends.overtime }"></b-icon>
                        </div>
                        <div class="cursor-pointer mb-1"
                          v-if="att.label == 14 && (att.check_in == '' && att.check_out == '')"
                          v-b-tooltip.hover.top="'Overtime (' + att.shift.name + ')'">
                          <b-icon icon="hourglass-split" class="fs-4" :style="{ color: legends.overtime }"></b-icon>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <div class="cursor-pointer mb-1" v-b-tooltip.hover.top="''">
                        <b-icon icon="dash-square" class="fs-4" :style="{ color: legends.unassigned }"></b-icon>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <template v-if="attendance.attendances_list_by_day[d]">
                      <template v-for="att in attendance.attendances_list_by_day[d]">
                        <!-- Unassigned (without shift) -->
                        <div class="cursor-pointer mb-1"
                          v-b-tooltip.hover.top="att.label == -1 ? 'Activity Log: ' + att.activity_log : 'Unassigned'"
                          v-if="att.shift == null && !([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].includes(att.label))">
                          <b-icon :icon="att.label == -1 ? 'person-dash-fill' : 'dash-square'"
                            :style="{ color: att.label == -1 ? '#dc3545' : '#6c757d' }" class="fs-4"></b-icon>
                        </div>

                        <!-- Scheduled (Future days, label 0 and shift exists) -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 0 && att.shift != null"
                          v-b-tooltip.hover.top="att.shift.name + '(Office Time: ' + moment(att.shift.start_time, 'HH:mm:ss').format('hh:mm A') + ' to ' + moment(att.shift.end_time, 'HH:mm:ss').format('hh:mm A') + ')'">
                          <b-icon icon="calendar-check-fill" class="fs-4" :style="{ color: att.shift.color }"></b-icon>
                        </div>

                        <!-- Leave Pending -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 7" v-b-tooltip.hover.top="'Leave Pending'">
                          <b-icon icon="clipboard-check" class="fs-4" :style="{ color: legends.on_leave }"></b-icon>
                        </div>

                        <!-- Leave Rejected -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 8" v-b-tooltip.hover.top="'Leave Rejected'">
                          <b-icon icon="clipboard-x" class="fs-4" :style="{ color: legends.on_leave }"></b-icon>
                        </div>

                        <!-- Swapped -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 13" v-b-tooltip.hover.top="'Swapped'">
                          <b-icon icon="arrow-down-up" class="fs-4" :style="{ color: legends.swapped }"></b-icon>
                        </div>

                        <!-- Present -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="[1, 11].includes(att.label)"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-check-fill" class="fs-4" :style="{ color: legends.present }"></b-icon>
                        </div>

                        <!-- Late -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 3"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-badge-fill" class="fs-4" :style="{ color: legends.late }"></b-icon>
                        </div>

                        <!-- Early Out -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 4"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-fill" class="fs-4" :style="{ color: legends.early_out }"></b-icon>
                        </div>

                        <!-- Late & Early Out -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 5"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="person-dash-fill" class="fs-4"
                            :style="{ color: legends.late__early_out }"></b-icon>
                        </div>

                        <!-- Absent -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 2" @click="requestAdjustmentForSubordinate(att)" v-b-tooltip.hover.top="'Absent'">
                          <b-icon icon="person-x-fill" class="fs-4" :style="{ color: legends.absent }"></b-icon>
                        </div>

                        <!-- On Leave (and half-leaves) -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)" v-if="att.label == 6"
                          v-b-tooltip.hover.top="att.label_text == 'x' ? 'On Leave' : att.label_text">
                          <b-icon v-if="att.label_text == 'On Leave' || att.label_text == 'x'" icon="person-dash-fill"
                            class="fs-4" :style="{ color: legends.on_leave }"></b-icon>
                          <b-icon v-else-if="att.label_text == 'First Half Leave'" icon="circle-half" class="fs-4"
                            :style="{ color: legends.present }"></b-icon>
                          <b-icon v-else-if="att.label_text == 'Second Half Leave'" icon="circle-half"
                            class="fs-4 rotate-180" :style="{ color: legends.present }"></b-icon>
                        </div>

                        <!-- Off Day -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 10" v-b-tooltip.hover.top="'Off Day'">
                          <b-icon icon="calendar-minus" class="fs-4" :style="{ color: legends.off_day }"></b-icon>
                        </div>

                        <!-- Compensatory Off Day -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 12"
                          v-b-tooltip.hover.top="'Compensatory Off Day'">
                          <b-icon icon="calendar-plus" class="fs-4"
                            :style="{ color: legends.compensatory_off }"></b-icon>
                        </div>

                        <!-- Holiday -->
                        <div class="cursor-pointer mb-1" v-if="att.label == 9" v-b-tooltip.hover.top="'Holiday'">
                          <b-icon icon="calendar-fill" class="fs-4" :style="{ color: legends.holiday }"></b-icon>
                        </div>

                        <!-- Overtime -->
                        <div class="cursor-pointer mb-1" @click="showActivity(att)"
                          v-if="att.label == 14 && (att.check_in != '' || att.check_out != '')"
                          v-b-tooltip.hover.top="att.check_in + ' to ' + att.check_out + '(' + att.label_text + ')'">
                          <b-icon icon="hourglass-split" class="fs-4" :style="{ color: legends.overtime }"></b-icon>
                        </div>
                        <div class="cursor-pointer mb-1"
                          v-if="att.label == 14 && (att.check_in == '' && att.check_out == '')"
                          v-b-tooltip.hover.top="'Overtime (' + att.shift.name + ')'">
                          <b-icon icon="hourglass-split" class="fs-4" :style="{ color: legends.overtime }"></b-icon>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <div class="cursor-pointer mb-1" v-b-tooltip.hover.top="'Unassigned'">
                        <b-icon icon="dash-square" class="fs-4" :style="{ color: legends.unassigned }"></b-icon>
                      </div>
                    </template>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{ blankmsg }}</div>
          <div v-else class="px-3">
            <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
              <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                <ul class="pagination b-pagination float-left mb-0 mt-1">
                  <li class="page-item disabled m-2">View</li>
                  <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                      @change="setFirstPage()"></b-form-select></li>
                  <li class="page-item disabled m-2">per page. Total {{ attendances.length }} records found.</li>
                </ul>
                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                  :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number
                  last-number></b-pagination-nav>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <b-modal id="bv-modal-request-attendance"
        :title="fdata.id != 0 ? 'Edit Requested Attendance' : 'Request Attendance'" hide-footer centered size="md">
      <b-overlay :show="loading">
        <div v-if="assignment">
          <div class="mb-3 border-0 bg-light company-form-container rounded p-3">
            <div class="d-flex justify-content-between align-items-start mb-3">
              <div>
                <h6 class="mb-1 font-weight-bold px-3 py-2" :style="{ background: assignment.shift.color + '40', color: assignment.shift.color }" style="border-radius: 6px;">
                  {{ assignment.shift ? assignment.shift.name : "" }}
                </h6>

                <small class="text-muted">
                  {{ assignment.day }}
                </small>
              </div>

              <div class="px-2 py-1 text-white d-inline radius-8 d-inline" :style="{
                backgroundColor: getLegendColor(new Date(assignment.period_date) < new Date() && assignment.label === 0 ? 'Absent' : assignment.label_text),
              }">
                {{ new Date(assignment.period_date) < new Date() && assignment.label === 0 ? 'Absent' : assignment.label_text }}
              </div>
            </div>

            <b-row>
              <b-col cols="12" md="6" class="mb-2">
                <div class="bg-white border rounded p-2 h-100">
                  <small class="text-muted d-block">Work Time</small>
                  <strong class="small">
                    {{ assignment.work_time }}
                  </strong>
                </div>
              </b-col>

              <b-col cols="12" md="6" class="mb-2">
                <div class="bg-white border rounded p-2 h-100">
                  <small class="text-muted d-block">Duty Time</small>
                  <strong class="small">
                    {{
                      assignment.shift ? (moment(assignment.shift.start_time, 'HH:mm').format('hh:mm A') + ' - ' + moment(assignment.shift.end_time, 'HH:mm').format('hh:mm A')) : "-"
                    }}
                  </strong>
                </div>
              </b-col>

              <b-col cols="12" md="6" class="mb-2">
                <div class="bg-white border rounded p-2 h-100">
                  <small class="text-muted d-block">Clock In</small>
                  <strong class="small">
                    {{ assignment.check_in }}
                  </strong>
                </div>
              </b-col>
              <b-col cols="12" md="6" class="mb-2">
                <div class="bg-white border rounded p-2 h-100">
                  <small class="text-muted d-block">Clock Out</small>
                  <strong class="small">
                    {{ assignment.check_out }}
                  </strong>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- Attendance Time -->
          <div class="row">
            <div class="col-6">
              <b-form-group label="Clock In Time" label-for="check_in_time" class="mb-2">
                <b-form-timepicker id="check_in_time" name="check_in_time" v-model="fdata.check_in_time"
                  data-vv-as="Requested Clock In Time" :state="validateState('check_in_time')" minutes-step="1"
                  reset-button :show-seconds="false" locale="en-US" :hour12="true" :label-close-button="'Save'"
                  aria-describedby="check_in_time-feedback" />
                <b-form-invalid-feedback id="check_in_time-feedback" v-if="veeErrors.has('check_in_time')">{{
                  veeErrors.first("check_in_time")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group label="Clock Out Time" label-for="check_out_time" class="mb-2">
                <b-form-timepicker id="check_out_time" name="check_out_time" v-model="fdata.check_out_time"
                  data-vv-as="Requested Clock Out Time" :state="validateState('check_out_time')" minutes-step="1"
                  reset-button :show-seconds="false" locale="en-US" :hour12="true" :label-close-button="'Save'"
                  aria-describedby="check_out_time-feedback" />
                <b-form-invalid-feedback id="check_out_time-feedback" v-if="veeErrors.has('check_out_time')">{{
                  veeErrors.first("check_out_time")
                }}</b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <small class="text-muted d-block mb-3">
            Select the attendance time that should be recorded.
          </small>
          <b-form-group id="comment-group" label="Reason" label-for="comment">
            <b-form-textarea id="comment" name="comment" rows="4" max-rows="6" no-resize v-model="fdata.comment"
              :state="validateState('comment')" aria-describedby="comment-feedback"
              data-vv-as="Reason"></b-form-textarea>
            <b-form-invalid-feedback id="comment-feedback">{{
              veeErrors.first("comment")
              }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- Actions -->
          <div class="d-flex justify-content-center pt-3">
            <b-button variant="primary" class="mr-2" @click="$bvModal.hide('bv-modal-request-attendance')">
              Cancel
            </b-button>

            <b-button variant="primary" @click="submitAttendanceRequest">
              {{ fdata.id != 0 ? "Update" : "Submit" }}
              Request
            </b-button>
          </div>
        </div>
      </b-overlay>
    </b-modal>


    <b-modal id="activity_logModal" size="xl" scrollable hide-footer title="Attendance Info">
      <div class="row no-margin">
        <div class="col-md-6">
          <div class="card punch-status">
            <div class="card-body">
              <h5 class="card-title">Timesheet <small class="text-muted">{{ period_date }}</small></h5>
              <p class="" v-if="shift && roster == 1">
                Shift:
                <small class="text-muted p-2" style="border-radius: 6px;"
                  :style="{ background: shift.color + '40', color: shift.color }">
                  {{ shift.name }}
                  ({{ moment(shift.start_time, 'HH:mm').format('hh:mm A') }} -
                  {{ moment(shift.end_time, 'HH:mm').format('hh:mm A') }})
                </small>
              </p>
              <div class="punch-det">
                <h6>Punch In at</h6>
                <p>{{ check_in }}</p>
              </div>
              <div class="punch-info">
                <div class="punch-hours">
                  <span>{{ work_time }}</span>
                </div>
              </div>
              <div class="punch-det">
                <h6>Punch Out at</h6>
                <p>{{ check_out }}</p>
              </div>
              <template v-if="assignment">
                <b-button v-if="[3,4,5].includes(assignment.label)" @click="requestAdjustmentForSubordinate(assignment)" class="w-100 mt-3">Request Adjustment</b-button>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card recent-activity">
            <div class="card-body">
              <h5 class="card-title">Activity</h5>
              <ul class="res-activity-list" v-if="activity_log">
                <li v-for="(activity, index) in activity_log">
                  <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                  <p class="mb-0" v-else>Punch Out at</p>
                  <p class="res-activity-time">
                    <i class="far fa-clock"></i>
                    {{ formateMe(activity) }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

  </b-overlay>
</template>
<script>
import moment from 'moment'
export default {

  mounted() {
    if (this.check_ce == 1) {
      if (this.ce_flg == 1)
        this.ce = true;
      else
        this.ce = false;
    }
  },
  components: {},
  data() {
    const now = new Date();
    return {
      loading: false,
      assignment: null,
      regularization: 0,
      fdata: {
          id: 0,
          check_in_time: null,
          check_out_time: null,
          comment: "",
          assignment_id: null,
      },
      showoverlay: false,
      empfile: null,
      shift: null,
      has_file: false,
      roster: 0,
      attendances: [],
      week_days_header: [],
      legends: {},
      head_color: { weekend: '#aaaaaa', holiday: '#aaaaaa' },
      search: '',
      length: 10,
      temp_length: 10,
      length_options: [],
      pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
      ce: true,
      grace_time_late_check_in: 0,
      grace_time_early_checkout: 0,
      blankmsg: 'Fetching data..',
      department_summary: [],
      employee_department_list: [],
      department_options: [
        { value: null, text: 'All Departments' }
      ],
      branch_options: [
        { value: null, text: 'All Branches' }
      ],
      jobposition_options: [
        { value: null, text: 'All Job Positions' }
      ],
      employee_type_options: [
        { value: null, text: 'All Employee Types' }
      ],
      summary_filter: {
        date: moment().format('YYYY-MM-DD'),
        department_id: null,
        branch_id: null,
        jobposition_id: null,
        employee_type_id: null,
      },
      errormsg: [],
      can_download_template: true,
      period_date: null,
      check_in: null,
      check_out: null,
      work_time: 0,
      break_time: 0,
      over_time: 0,
      activity_log: null,
      edit_date: null,
      has_pending_leave: false,
      employee_id: 0,
      month: ('0' + (new Date().getMonth() + 1)).slice(-2),
      year: now.getFullYear(),
      legend: { 'absent': '#DE0000', 'late_early': '#BF8F00', 'ontime': '#18A022', 'auto_checkout': '#DE0000' }
    };
  },
  methods: {
    moment,
    getLegendColor(label) {
      let key = label.toLowerCase().replace(/ /g, '_').replace(/&/g, '');
      if (key === 'early_out') key = 'early';
      if (key === 'late_early_out') key = 'late_early';
      return this.legends[key];
    },
    getCompanyLeaveSettings: function () {
      if (!this.checkNet()) return false;
      axios.get(this.$api_url + '/front/leave-attendance/company/leave/settings').then(function (response) {

        if (response.data.length != 0) {
          this.roster = response.data.roster;
          this.regularization = response.data.regularization;
        }
      }.bind(this));
    },


requestAdjustmentForSubordinate: function (att) {
      if(this.regularization == 0) return;
      if(!this.checkNet()) return false;
      this.$bvModal.hide('activity_logModal');
          let formData = new FormData();
          formData.append('zombie', att.employee_id);
          axios.post(this.$api_url+'/front/leave-attendance/manager/set', formData).then(function (response)
              {                                                                    
                  this.reqAttendanceModal(att, att.requested)
              }.bind(this))
              .catch(function (error) 
              {
                  this.serverError(error);
              });
    },

    reqAttendanceModal(row, requested = null) {
      this.fdata.assignment_id = row.id;
      this.assignment = row;
      if (requested != null) {
        this.fdata.id = requested.id;
        this.fdata.check_in_time = requested.check_in_time;
        this.fdata.check_out_time = requested.check_out_time;
        this.fdata.comment = requested.comment;
      } else {
        this.fdata.id = 0;
        this.fdata.check_in_time = null;
        this.fdata.check_out_time = null;
        this.fdata.comment = "";
      }
      this.$bvModal.show("bv-modal-request-attendance");
    },
    submitAttendanceRequest() {
      if(this.fdata.check_in_time == null && this.fdata.check_out_time == null) {
        this.$bvToast.toast('No time selected', {
          title: 'Error',
          solid: true,
          variant: 'danger'
        });
        return;
      }
      this.loading = true;
      let formData = new FormData();
      for (let [k, v] of Object.entries(this.fdata)) {
        formData.append(k, v);
      }
      axios
        .post(
          this.$api_url + "/front/leave-attendance/attendance/request",
          formData
        )
        .then((response) => {
          this.$bvToast.toast(response.data.message, {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.$bvModal.hide("bv-modal-request-attendance");
          this.getEmployeesAttendance();
          this.loading = false;
        }).catch(e=> {
          this.loading = false;
          this.serverError(e);
        });
    },


    

    reloadData: function () {
      this.getEmployeesAttendance();
      this.getDepartmentAttendanceSummary();
    },
    getDepartmentAttendanceSummary(export_flg = 0) {
      if (!this.checkNet()) return false;

      this.showoverlay = true;

      const axiosConfig = {
        params: {
          date: this.summary_filter.date,
          department_id: this.summary_filter.department_id,
          branch_id: this.summary_filter.branch_id,
          jobposition_id: this.summary_filter.jobposition_id,
          employee_type_id: this.summary_filter.employee_type_id,
          export_flg: export_flg,
        }
      };

      if (export_flg == 1) {
        axiosConfig.responseType = 'blob';
      }

      axios.get(this.$api_url + '/front/leave-attendance/attendance/department-summary', axiosConfig)
        .then(response => {
          if (export_flg == 1) {
            this.global_download_file_content(response);
          } else {
            const data = response.data || {};

            this.department_summary = data.summary || [];
            this.employee_department_list = data.employee_department_list || [];
          }

          this.showoverlay = false;
        })
        .catch(error => {
          this.showoverlay = false;
          this.serverError(error);
        });
    },
    loadFilterOptions() {
      axios.get(this.$api_url + '/front/branch/list').then(response => {
        this.branch_options = [
          { value: null, text: 'All Branches' },
          ...response.data.map(item => ({
            value: item.id,
            text: item.name
          }))
        ];
      });
      axios.get(this.$api_url + '/front/department/list').then(response => {
        this.department_options = [
          { value: null, text: 'All Departments' },
          ...response.data.map(item => ({
            value: item.id,
            text: item.name
          }))
        ];
      });
      axios.get(this.$api_url + '/front/jobposition/list').then(response => {
        this.jobposition_options = [
          { value: null, text: 'All Job Positions' },
          ...response.data.map(item => ({
            value: item.value,
            text: item.text
          }))
        ];
      });
      axios.get(this.$api_url + '/front/employeetype/list').then(response => {
        this.employee_type_options = [
          { value: null, text: 'All Employee Types' },
          ...response.data.map(item => ({
            value: item.value,
            text: item.text
          }))
        ];
      });
    },
    resetdata: function () {
      this.period_date = null;
      this.check_in = null;
      this.check_out = null;
      this.work_time = 0;
      this.break_time = 0;
      this.over_time = 0;
    },
    resetSummaryFilter() {
      this.summary_filter.date = moment().format('YYYY-MM-DD');
      this.summary_filter.department_id = null;
      this.summary_filter.branch_id = null;
      this.summary_filter.jobposition_id = null;
      this.summary_filter.employee_type_id = null;
      this.getDepartmentAttendanceSummary();
    },
    formateMe: function (minutes) {
      if (minutes == null) return '..';
      return moment(minutes, "YYYY-mm-dd hh:mm:ss").format('LT');
    },
    showActivity: function (ins) {
      this.assignment = ins;
      this.resetdata();

      this.period_date = ins.period_date;
      this.check_in = ins.check_in;
      this.check_out = ins.check_out;

      this.work_time = ins.work_time;
      this.break_time = ins.break_time;
      this.over_time = ins.over_time;
      if (ins.activity_log == null) {
        return;
      }

      this.activity_log = (ins.activity_log.split(',') || []).slice().sort((a, b) => {
        return new Date(a.time) - new Date(b.time);
      });
      this.employee_id = ins.employee_id;
      this.shift = ins.shift;

      this.$bvModal.show('activity_logModal');

    },

    setEmployee(x) {
      let currentObj = this;
      let formData = new FormData();
      formData.append('employee_id', x);
      axios.post(this.$api_url + '/front/employee/setemployee', formData)
        .then(function (response) {
          return;

        }.bind(this))
        .catch(function (error) {
          currentObj.showoverlay = false;
          currentObj.serverError(error);
        });
    },

    getEmployeesAttendance: function () {
      if (!this.checkNet()) return false;
      let currentObj = this;

      this.showoverlay = true;

      var today = new Date();

      let month = this.month;
      let year = this.year;
      let fiscal_year = this.getCurrentFinancialYear();
      let years = fiscal_year.split('-');

      //if ((today.getMonth() + 1) <= 6) year = years[0];
      // if (month <= 6) year = years[1];
      // else year = years[0];

      // this.year = year;



      if ((today.getFullYear() == this.year) && (month > (today.getMonth() + 1))) {
        this.can_download_template = false;

        this.month = (today.getMonth() + 1);

        currentObj.$bvToast.toast("Future date can't be accessed!", {
          title: `Warning`,
          variant: 'warning',
          solid: true
        });

        return false;
      }
      else {
        this.can_download_template = true;;
      }
      this.attendances = [];
      currentObj.showoverlay = true;
      axios.get(this.$api_url + '/front/leave-attendance/attendance/month?approver=1', {
        params: {
          month: month,
          year: year,
          export_flg: 0,
        }
      }).then(function (response) {
        this.attendances = response.data.attendances_list;
        this.legends = response.data.legends || {};

        if (this.attendances.length == 0)
          this.blankmsg = "Looks like you have not added any employee attendance yet for the selected month.";


        this.week_days_header = response.data.week_days_header;
        this.head_color = response.data.head_color;

        this.length_options = [
          { value: 10, text: "10" }, 
          { value: 20, text: "20" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 500, text: "500" },
          { value: this.attendances.length, text: "All" }
        ];
        this.people = this.attendances.length;

        this.today = response.data.today;

        this.grace_time_late_check_in = response.data.grace_time_late_check_in;
        this.grace_time_early_checkout = response.data.grace_time_early_checkout;

        currentObj.showoverlay = false;

      }.bind(this)).catch(function (error) {
        currentObj.showoverlay = false;
        currentObj.serverError(error);
      });


    },
    setFirstPage: function () {
      this.pagination.currentPage = 1;
      this.length = this.temp_length;
    },

    downloadData: function () {
      if (this.attendances.length > 0) {
        if (!this.checkNet()) return false;
        this.showoverlay = true;
        axios.get(this.$api_url + '/front/leave-attendance/attendance/month?approver=1', {
          params: {
            month: this.month,
            year: this.year,
            export_flg: 1,
          },
          responseType: 'blob'
        }).then((response) => {
          this.global_download_file_content(response);
          this.showoverlay = false;
        }).catch((error) => {
          this.serverError(error);
          this.showoverlay = false;
        });
      }
    }


  },
  created: function () {
    this.loadFilterOptions();
    this.getDepartmentAttendanceSummary();
    this.getEmployeesAttendance();
    this.getCompanyLeaveSettings();

  },
  computed:
  {
    today() {
      const date = new Date();

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    summaryRatio() {
      const base = Number(this.summaryTotal.total || 0);

      if (base === 0) {
        return {
          present: '0.00',
          late: '0.00',
          early: '0.00',
          absent: '0.00',
          leave: '0.00',
          night_shift: '0.00',
          weekly_off: '0.00',
          unassigned: '0.00',
          total: '0.00',
        };
      }

      return {
        present: ((Number(this.summaryTotal.present || 0) / base) * 100).toFixed(2),
        late: ((Number(this.summaryTotal.late || 0) / base) * 100).toFixed(2),
        early: ((Number(this.summaryTotal.early || 0) / base) * 100).toFixed(2),
        leave: ((Number(this.summaryTotal.leave || 0) / base) * 100).toFixed(2),
        absent: ((Number(this.summaryTotal.absent || 0) / base) * 100).toFixed(2),
        night_shift: ((Number(this.summaryTotal.night_shift || 0) / base) * 100).toFixed(2),
        weekly_off: ((Number(this.summaryTotal.weekly_off || 0) / base) * 100).toFixed(2),
        unassigned: ((Number(this.summaryTotal.unassigned || 0) / base) * 100).toFixed(2),
        total: '100.00',
      };
    },
    summaryTotal() {
      return this.department_summary.reduce((total, row) => {
        total.present += Number(row.present || 0);
        total.late += Number(row.late || 0);
        total.early += Number(row.early || 0);
        total.absent += Number(row.absent || 0);
        total.leave += Number(row.leave || 0);
        total.night_shift += Number(row.night_shift || 0);
        total.weekly_off += Number(row.weekly_off || 0);
        total.unassigned += Number(row.unassigned || 0);
        total.total += Number(row.total || 0);

        return total;
      }, {
        present: 0,
        late: 0,
        early: 0,
        absent: 0,
        leave: 0,
        night_shift: 0,
        weekly_off: 0,
        unassigned: 0,
        total: 0,
      });
    },
    filteredData() {
      let filtered_list = this.attendances || [];
      if (this.search) {
        const q = this.search.toLowerCase();
        filtered_list = filtered_list.filter(row =>
          Object.keys(row).some(key => String(row[key]).toLowerCase().indexOf(q) > -1)
        );
      }
      return filtered_list;
    },
    paginatedData() {
      return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
    },


  }
}
</script>
